import { ReactNode, createContext, useContext, useState } from 'react'
import { Modal } from 'src/components'
import { ModalContextProps, ModalProviderProps } from './types'

const ModalContext = createContext({} as ModalContextProps)

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [showModal, setShowModal] = useState(false)
  const [modalContent, setModalContent] = useState<ReactNode>(null)

  const closeModal = () => {
    document.body.classList.remove('_overflow-hidden')
    setShowModal(false)
  }

  const openModal = () => {
    document.body.classList.add('_overflow-hidden')
    setShowModal(true)
  }

  return (
    <ModalContext.Provider
      value={{
        showModal,
        setModalContent,
        closeModal,
        openModal
      }}
    >
      {children}
      <Modal show={showModal} onOpen={openModal} onClose={closeModal}>
        {modalContent}
      </Modal>
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error('Modal Context is not available')
  }

  return context
}
